export const SET_USER_MESSAGES = "SET_USER_MESSAGES";
export const SET_GROUP_MESSAGES = "SET_GROUP_MESSAGES"
export const SET_CONTACTS_TOTAL = "SET_CONTACTS_TOTAL";
export const SET_USER_ATTACHMENTS = "SET_USER_ATTACHMENTS";
export const SET_GROUP_ATTACHMENTS = "SET_GROUP_ATTACHMENTS";
export const SET_GALLERY = "SET_GALLERY";
export const SET_ADMIN_USER_MESSAGES = "ADMIN_USER_MESSAGES";
export const SET_ADMIN_GROUP_MESSAGES = "ADMIN_GROUP_MESSAGES";
export const SET_GROUP_SEEN = "SET_GROUP_SEEN";
